<template>
  <v-dialog v-model="dialogQrcode" scrollable persistent max-width="500px" max-height="350px">
    <v-card style="border-radius:20px;">
      <v-card tile>
        <v-toolbar card style="background: #1a222c !important;">
          <v-toolbar-title class="white--text CSChatThai" style="white-space: nowrap; width: 100%; overflow: hidden; text-overflow: ellipsis;">
           <span class="headline CSChatThai" >
              <v-icon color="white">group</v-icon>&nbsp;&nbsp;{{$t('Dialog.group.group')}} {{detail.group_name}}
            </span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="Close()">
            <v-icon style="color: white !important; font-size: 25px !important;">clear</v-icon>
          </v-btn>
        </v-toolbar>
      </v-card>
      <v-card-text style="margin-top:0vh; margin-bottom:0vh; justify-content: center !important;">
        <v-container grid-list-md>
          <v-layout wrap >
            <v-flex xs12 sm12 md12>
              <h3 class="header" style="text-overflow: ellipsis !important; overflow: hidden !important;">{{$t('Dialog.group.detailQrjoingroup')}} {{detail.group_name}}</h3>
            </v-flex>
            <v-flex xs12 sm12 md12>
              <div>
                <!-- <p>QR code</p>  -->
                <p style="justify-content: center; display: flex;">
                  <qrcode :value="tokenuserQR" style="width: 180px; height: 180px;" id="downloadqr"></qrcode>
                </p>
                <p>{{$t('Dialog.group.detailQrcode')}}
                <a href="#" class="button" id="btn-download" :download="'qrcode_group_' + detail.group_name + '.png'" @click="loadqr()">{{$t('AnswerQuestion.download')}}</a></p>
              </div>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import Vue from 'vue'
import VueQrcode from '@xkeshi/vue-qrcode'
import { Decode } from '@/services'
Vue.component(VueQrcode.name, VueQrcode)
export default {
  props: {dialogQrcode: false, detail: {}},
  data: () => ({
    token: '',
    tokenuserQR: ''
  }),
  created () {
    var decoded = JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
    this.token = decoded['tokenuser']
  },
  computed: {
  },
  watch: {
    detail () {
      // this.tokenuserQR = 'https://com.oneplatform.android.onechat.group/u/' + btoa(this.detail.group_id)
      this.tokenuserQR = process.env.APIQRcode + '/qrcode/group?id=' + btoa(this.detail.group_id)
    }
  },
  methods: {
    Close () {
      this.$emit('closeQrcode', false)
    },
    loadqr () {
      var cnvs = document.getElementById('downloadqr')
      var button = document.getElementById('btn-download')
      var dataURL = cnvs.toDataURL('image/png')
      button.href = dataURL
    }
  }
}
</script>
<style  lang="css" scoped>
.alligator-turtle {

  object-fit: cover;
  object-position: 50% 0;
}
.CSChatThai {
 font-family: 'CS ChatThaiUI' !important;
 word-wrap: break-word;
}
>>>.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) .v-input__slot {
  /*box-shadow: none;*/
  border-width: thin !important;
  border-style: solid !important;
  border-radius: 20px !important;
  border-color: #808080a6 !important;
  box-shadow: none !important;
}
.btnallow {
  font-size: 9px !important;
  border-radius: 5px;
  margin-left: 0vw !important;
  margin-right: 0vw !important;
  background: #2562af !important;
  color: white !important;
}
.btncancel {
  font-size: 9px !important;
  border-radius: 5px;
  margin-left: 0vw !important;
  margin-right: 0vw !important;
  background: #e0e0e0 !important;
  color: black !important;
}
</style>



// WEBPACK FOOTER //
// src/components/mobile/dialog/QrcodeDialogMobile.vue